/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Technology } from './Technology';
import {
    TechnologyFromJSON,
    TechnologyFromJSONTyped,
    TechnologyToJSON,
    TechnologyToJSONTyped,
} from './Technology';

/**
 * 
 * @export
 * @interface PaginatedTechnologyList
 */
export interface PaginatedTechnologyList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTechnologyList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTechnologyList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTechnologyList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Technology>}
     * @memberof PaginatedTechnologyList
     */
    results: Array<Technology>;
}

/**
 * Check if a given object implements the PaginatedTechnologyList interface.
 */
export function instanceOfPaginatedTechnologyList(value: object): value is PaginatedTechnologyList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedTechnologyListFromJSON(json: any): PaginatedTechnologyList {
    return PaginatedTechnologyListFromJSONTyped(json, false);
}

export function PaginatedTechnologyListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedTechnologyList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(TechnologyFromJSON)),
    };
}

  export function PaginatedTechnologyListToJSON(json: any): PaginatedTechnologyList {
      return PaginatedTechnologyListToJSONTyped(json, false);
  }

  export function PaginatedTechnologyListToJSONTyped(value?: PaginatedTechnologyList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(TechnologyToJSON)),
    };
}

